(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.factory.sharing-links'

  angular
    .module(MODULE_NAME, [])
    .factory('SharingLinks', sharingLinksService)

  sharingLinksService.$inject = ['$httpParamSerializer']
  function sharingLinksService ($httpParamSerializer) {
    var service = {
      create: createSharingLink
    }

    return service

    /**
     * Create a sharing link to service using args.
     *
     * The following services are supported, listed here with their corresponding arguments:
     *      var services = {
     *          email      : {
     *              title : string, // Item title.
     *              url   : string, // Url to be shared.
     *          },
     *          facebook   : {
     *              url   : string, // Url to be shared.
     *          },
     *          googleplus : {
     *              url   : string, // Url to be shared.
     *          },
     *          pinterest  : {
     *              imageUrl : string, // Main content image URL.
     *              title    : string, // Item title.
     *              url      : string, // Url to be shared.
     *          },
     *          twitter    : {
     *              title : string, // Item title.
     *              url   : string, // Url to be shared.
     *          },
     *      }
     */
    function createSharingLink (service, args) {
      var queryVars = {}

      switch (service) {
        case 'email':
          queryVars = {
            body: args.title + '%0D%0A %0D%0A' + args.url,
            subject: args.title
          }
          return 'mailto:' + $httpParamSerializer(queryVars)

        case 'facebook':
          queryVars = {
            u: args.url
          }
          return 'https://www.facebook.com/sharer/sharer.php?' + $httpParamSerializer(queryVars)

        case 'googleplus':
          queryVars = {
            url: args.url
          }
          return 'https://plus.google.com/share?' + $httpParamSerializer(queryVars)

        case 'pinterest':
          queryVars = {
            description: args.title,
            media: args.imageUrl,
            url: args.url
          }
          return 'http://pinterest.com/pin/create/button/?' + $httpParamSerializer(queryVars)

        case 'twitter':
          queryVars = {
            text: args.title,
            url: args.url
          }
          return 'https://www.twitter.com/intent/tweet?' + $httpParamSerializer(queryVars)
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/factory/sharing-links.js